<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('investorInfo.title') }}</h1>
          <investor-form :investorId="$route.params.investorId" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import InvestorForm from '@/components/investor/InvestorForm.vue';

export default {
  name: 'InvestorInfoPage',
  components: {
    InvestorForm,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
